<!--
  ~ Copyright (c) 2019 Hawaii Information Consortium
  ~ 201 Merchant St #1805, Honolulu, HI 96813
  ~ All rights reserved.
  ~
  ~ This software is the confidential and proprietary information
  ~ of Hawaii Information Consortium. ("Confidential Information"). You
  ~ shall not disclose such Confidential Information and shall use
  ~ it only in accordance with the terms of the license agreement
  ~ you entered into with HIC.
  -->

<div class="modal-content">
  <div id="report">
    <div class="modal-header">
      <h1 class="modal-title" ngbAutofocus tabindex="-1">
        <div>
          Summary of Purchase <span *ngIf="report.purchaseType === ReportType.PAQ">AQ </span>Transactions
        </div>
      </h1>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="report">
          <table class="table table-bordered table-responsive-sm">
            <thead class="thead-dark">
            <tr>
              <th>Month</th>
              <th>Year</th>
              <th>Purchase Receipt Reports</th>
              <th>Pieces Purchased</th>
              <th *ngIf="!isPaq()">Lbs. Purchased</th>
              <th>Value</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of report.elements">
              <td>{{item.month}}</td>
              <td>{{item.year}}</td>
              <td class="text-right">{{0 == item.reportsNumber ? '--' : item.reportsNumber | number}}</td>
              <td class="text-right">{{0 == item.piecesPurchased ? '--' : item.piecesPurchased | number}}</td>
              <td class="text-right" *ngIf="!isPaq()">{{0 == item.lbsPurchased ? '--' : item.lbsPurchased | number}}</td>
              <td class="text-right">{{0 == item.amount ? '--' : item.amount | bigCurrency}}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="lead">
              <td>SUM</td>
              <td></td>
              <td class="text-right">{{report.reportsNumber | number}}</td>
              <td class="text-right">{{report.piecesPurchased | number}}</td>
              <td class="text-right" *ngIf="!isPaq()">{{report.lbsPurchased | number}}</td>
              <td class="text-right">{{report.amount | bigCurrency }}</td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div> <!-- modal-body-->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-xs-block btn-primary btn" (click)="onExport()">
      <i class="fas fa-save"> </i> Export
    </button>
    <button type="button" class="btn-xs-block btn-primary btn" (click)="onPrint()">
      <i class="fas fa-print"> </i> Print
    </button>
    <button type="button" class="btn-xs-block btn btn-secondary btn" (click)="onCancel()">
      <i class="fas fa-times"> </i> Return to Reports
    </button>
  </div>
</div>
